import { type Duration } from 'date-fns'

export const useTimeSlot = () => {
  // plannerごとに値を変えたくなったり、頻繁に変えるようならバックエンドから返すようにする
  const unavailableDurationFromNow: Duration = {
    days: 1,
  }
  return { unavailableDurationFromNow }
}
